export const LOGIN_CONSTANTS = {
    durationIsLoggedInCookie: 5
};
